import { EhrName } from "@metriport/shared-internal";

export type EhrConfig = {
  id: string;
  name: EhrName;
  description: string;
};

const ehrDescriptions: Record<EhrName, string> = {
  [EhrName.Healthie]: "Patient lookup and linking",
  [EhrName.Athena]: "Patient lookup",
  [EhrName.Canvas]: "Patient lookup",
  [EhrName.Elation]: "Patient lookup and linking",
  [EhrName.EClinicalWorks]: "Patient lookup",
  [EhrName.Salesforce]: "Patient lookup",
  [EhrName.PracticeFusion]: "Patient lookup",
  [EhrName.Embed]: "Not implemented",
};

export const notImplementedEHRs = [EhrName.Embed];

export const EHR_LIST: EhrConfig[] = Object.values(EhrName)
  .filter(name => !notImplementedEHRs.includes(name))
  .map(name => ({
    id: name.toLowerCase(),
    name,
    description: ehrDescriptions[name],
  }));

const EHR_ROUTE_ID_SET = new Set(EHR_LIST.map(e => e.id));

/**
 * Resolves `cx_mapping.source` from OSS to a segment under `/ehr/:cxId/:ehrId`, or `undefined` if unknown.
 */
export function ehrIdFromMappingSource(source: string): string | undefined {
  const key = source.trim().toLowerCase();
  if (key === "athenahealth") return "athena";
  return EHR_ROUTE_ID_SET.has(key) ? key : undefined;
}
